"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var hooks_1 = require("../../../api/hooks");
var Alert_styled_1 = require("./Alert.styled");
var atomic_ui_lib_lts_1 = require("@greatmindsorg/atomic-ui-lib-lts");
var styled_components_1 = require("styled-components");
var DefaultAlertProps = {
    alertType: 'toast',
    content: {
        title: 'Oops...',
        message: 'Something went wrong. Please try again!',
    },
    timeout: 5000,
};
var Alert = function (props) {
    var alertProps = __assign(__assign({}, DefaultAlertProps), props);
    (0, hooks_1.useMount)(function () {
        var timer;
        if (props.timeout) {
            timer = setTimeout(props.handleClose, props.timeout + 100);
        }
        return function () {
            if (timer) {
                clearTimeout(timer);
            }
        };
    });
    // ------------------------ Render
    return ((0, jsx_runtime_1.jsx)(Alert_styled_1.StyledAlert, { "aria-live": "polite", "aria-atomic": "true", children: (0, jsx_runtime_1.jsx)(styled_components_1.ThemeProvider, { theme: atomic_ui_lib_lts_1.baseTheme, children: (0, jsx_runtime_1.jsx)(atomic_ui_lib_lts_1.Alert, __assign({}, alertProps)) }) }));
};
exports.Alert = Alert;
exports.default = exports.Alert;
